import * as extendActionType from '../extendActionType';

export const GET_ENCOUNTERS_LIST = 'encounters/GET_ENCOUNTERS_LIST';
export const ADD_ENCOUNTER = 'encounters/ADD_ENCOUNTER';
export const EDIT_ENCOUNTER = 'encounters/EDIT_ENCOUNTER';
export const ADD_ENCOUNTER_DIALOG = 'encounters/ADD_ENCOUNTER_DIALOG';
export const DELETE_ENCOUNTER = 'encounters/DELETE_ENCOUNTER';
export const SEND_ENCOUNTER = 'encounters/SEND_ENCOUNTER';
export const SEND_ENCOUNTER_DIALOG = 'encounters/SEND_ENCOUNTER_DIALOG';
export const DOWNLOAD_ENCOUNTER_DIALOG = 'encounters/DOWNLOAD_ENCOUNTER_DIALOG';
export const GET_ENCOUNTER = 'encounters/GET_ENCOUNTER';
export const GET_DOWNLOAD_LINK = 'encounters/GET_DOWNLOAD_LINK';
export const GET_ENCOUNTERS_FOR_DROPDOWN = 'encounters/GET_ENCOUNTER_FOR_DROPDOWN';
export const SYNC_ENCOUNTER = 'encounters/SYNC_ENCOUNTER';

export function syncEncounter(encounterId) {
    return {
        type: SYNC_ENCOUNTER,
        httpRequest: {
            method: 'post',
            path: `/encounters/erx/sync/${encounterId}`,
        },
    };
}

export function getEncountersList(patientId, {
    offset, limit, filter, syncEncounterId,
}) {
    return {
        type: GET_ENCOUNTERS_LIST,
        httpRequest: {
            method: 'get',
            path: `/encounters/${patientId}/list`,
            params: {
                offset,
                limit,
                search: filter && filter.search && filter.search.trim(),
                doctorId: filter && filter.doctorId,
                type: filter && filter.encounterType,
                syncEncounterId,
            },
        },
        offset,
        limit,
    };
}

export function getEncountersForDropdown(patientId) {
    return {
        type: GET_ENCOUNTERS_FOR_DROPDOWN,
        httpRequest: {
            method: 'get',
            path: `/encounters/dropdown/${patientId}`,
        },
    };
}

export function getDownloadLink(encounterId, fields) {
    return {
        type: GET_DOWNLOAD_LINK,
        httpRequest: {
            method: 'post',
            path: `/encounters/download/${encounterId}`,
            data: {
                fields,
            },
        },
    };
}

export function getEncounter(encounterId) {
    return {
        type: GET_ENCOUNTER,
        httpRequest: {
            method: 'get',
            path: `/encounters/${encounterId}`,
        },
    };
}

export function sendEncounter(encounterId, data) {
    return {
        type: SEND_ENCOUNTER,
        httpRequest: {
            method: 'post',
            path: `/encounters/send/${encounterId}`,
            data,
        },
    };
}


export function addEncounter(patientId, {datetime, type, reason}) {
    return {
        type: ADD_ENCOUNTER,
        httpRequest: {
            method: 'post',
            path: `/encounters/${patientId}`,
            data: {
                type,
                reason,
                datetime,
            },
        },
        encounterType: type,
        reason,
        datetime,
    };
}

export function editEncounter(encounterId, {datetime, type, reason}) {
    return {
        type: EDIT_ENCOUNTER,
        httpRequest: {
            method: 'put',
            path: `/encounters/${encounterId}`,
            data: {
                type,
                reason,
                datetime,
            },
        },
        fields: {
            type,
            reason,
            encounterDatetime: datetime,
        },
        encounterId,
    };
}

export function deleteEncounter(encounterId) {
    return {
        type: DELETE_ENCOUNTER,
        httpRequest: {
            method: 'del',
            path: `/encounters/${encounterId}`,
        },
        encounterId,
    };
}

export function showAddEncounter(encounter) {
    return {
        type: extendActionType.show(ADD_ENCOUNTER_DIALOG), encounter,
    };
}

export function hideAddEncounter() {
    return {type: extendActionType.clean(ADD_ENCOUNTER_DIALOG)};
}

export function showSendEncounter(encounterId) {
    return {
        type: extendActionType.show(SEND_ENCOUNTER_DIALOG),
        encounterId,
    };
}

export function hideSendEncounter() {
    return {type: extendActionType.clean(SEND_ENCOUNTER_DIALOG)};
}

export function showDownloadEncounter(encounterId) {
    return {
        type: extendActionType.show(DOWNLOAD_ENCOUNTER_DIALOG),
        encounterId,
    };
}

export function hideDownloadEncounter() {
    return {type: extendActionType.clean(DOWNLOAD_ENCOUNTER_DIALOG)};
}



// WEBPACK FOOTER //
// ./src/reducers/encounters/encountersActions.js